import React from 'react';
import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Box,
  Spinner,
} from '@chakra-ui/react';

const levelLabel = (level = 'medium') => ({
  low: 'normal',
  medium: 'average',
  high: 'high',
}[level] || 'normal');

const feeDescription = ({ chain, price, level }) =>
  `${chain ? `${chain} gas` : 'Gas'} fees are currently ${price} Gwei, which is ${level}`;

const GasPriceAlert = ({
  chain,
  price = 'unknown',
  level = 'high',
  loading = false,
  ...props
}) => (
  <Alert
    status="warning"
    variant="subtle"
    justifyContent="flex-start"
    alignItems="flex-start"
    fontSize="sm"
    style={{
      padding: '1.5em',
      marginTop: '1em',
      marginBottom: '1.5em',
      background: 'white',
      border: '1px solid orange',
    }}
    {...props}
  >
    {loading
      ? (
        <Spinner
          size="md"
          thickness="2px"
          speed="1s"
          style={{ marginTop: '0.125em', marginRight: '0.5em' }}
          color="orange"
        />
      )
      : (
        <AlertIcon
          w={6}
          h={6}
          style={{ marginTop: '0.125em', marginRight: '0.5em' }}
        />
      )}
    <Box flex="1">
      <AlertTitle style={{ marginBottom: '1em' }}>
        You may experience some delay in transferring your asset.
      </AlertTitle>
      <AlertDescription>
        {feeDescription({ chain, price, level: levelLabel(level) })}
        . That means the queue is busy and there might be some delay in transferring your asset.
      </AlertDescription>
    </Box>
  </Alert>
);

export default GasPriceAlert;
